export default {
  'viewPayment.approverOne': 'Approver One',
  'viewPayment.approverTwo': 'Approver Two',
  'viewPayment.approverOneApprovedOn': 'Approver One Date',
  'viewPayment.approverTwoApprovedOn': 'Approver Two Date',
  'viewPayment.applyTo': 'Apply To',
  'viewPayment.bankTraceNum': 'Bank Trace Number',
  'viewPayment.enteredOn': 'Entered On',
  'viewPayment.loanAccountName': 'Loan Account Name',
  'viewPayment.paymentsCount': '(#) payments',
  'viewPayment.paymentInformation': 'Payment Information',
  'viewPayment.paymentOptions': 'Payment Options',
  'viewPayment.pendingNumber': 'Pending number',
  'viewPayment.templateName': 'Template name',
  'viewPayment.title': 'View Payment',
  'viewPayment.wireEntryUser': 'Wire Entry/User',
  'viewPayment.approve.message.title': 'Payment(s) approved.',
  'viewPayment.delete.message.title': 'Payment(s) deleted.',
  'viewPayment.reject.message.title': 'Payment(s) rejected.',
  'viewPayment.paymentDetails': 'Payment Details',
  'viewPayment.missingAccountName': 'Missing Account Name',
  'viewPayment.missingAccountNumber': 'Missing Account Number'
};
